import { render, staticRenderFns } from "./MinorCardSign.vue?vue&type=template&id=333f4ff0&scoped=true&"
import script from "./MinorCardSign.vue?vue&type=script&lang=js&"
export * from "./MinorCardSign.vue?vue&type=script&lang=js&"
import style0 from "./MinorCardSign.vue?vue&type=style&index=0&id=333f4ff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f4ff0",
  null
  
)

export default component.exports